import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=ee82b1e4&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=ee82b1e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee82b1e4",
  null
  
)

component.options.__file = "src/components/goods/GoodsDetail.vue"
export default component.exports